import Vue from "vue";

function LoadChildren(product, index, addedProducts, products) {
    products.splice(index + 1, 0, ...addedProducts);
    return products;
}

function RemoveChildren(products, index, childrenCount) {
    products.splice(index + 1, childrenCount);

    return products;
}

Vue.component("party-coverage-management", {
    props: ["classificationCode", "description"],
    data() {
        return {
            loading: true,
            parties: [],

            products: [],
            showCoverageFormModal: false,
            selectedCoverage: null,
            selectedProduct: null,
            selectedParty: null,
            productName: null,
            coverage: 0,
            isBulk: false
        }
    },
    methods: {
        initialize() {
            const self = this;

            self.loadParties();
            self.loadHierarchies(null);
        },
        loadParties() {
            const self = this;

            self.loading = true;

            self.$services.partyCoveragesService.getParties({
                language: window.currentLanguage,
                classificationSystemCode: self.classificationCode,
            }).then((data) => {
                self.parties = data;                
            });
        },
        loadHierarchies(parentId) {
            const self = this;                       

            self.$services.classificationHierarchies.getList({
                classificationSystemCode: self.classificationCode,
                language: window.currentLanguage,
                parentId: parentId
            }).then((data) => {
                self.products = data;
                self.loading = false;
            });
        },
        loadChildren(product, index) {
            const self = this;            

            if (product != null) {
                if (product.loaded) {
                    product.icon = "caret-right";
                    product.loaded = false;

                    self.products = RemoveChildren(self.products, index, product.childrenCount);
                }
                else {
                    product.icon = "caret-down";
                    product.loaded = true;

                    self.$services.classificationHierarchies.getList({
                        classificationSystemCode: self.classificationCode,
                        language: window.currentLanguage,
                        parentId: product.id
                    }).then((data) => {
                        self.products = LoadChildren(product, index, data, self.products);
                    });
                }
            }
        },
        discardCoverage() {
            this.showCoverageFormModal = false;
        },
        saveCoverage() {
            const self = this;

            switch (self.coverage) {
                case '0':
                    if (self.isBulk) {
                        self.selectedParty.pack = "far";
                        self.selectedParty.icon = "star";
                        self.selectedParty.type = "is-success";
                    }
                    else {
                        self.selectedCoverage.pack = "far";
                        self.selectedCoverage.icon = "star";
                        self.selectedCoverage.type = "is-success";
                    }
                    break;
                case '1':
                    if (self.isBulk) {
                        self.selectedParty.pack = "fas";
                        self.selectedParty.icon = "star-half";
                        self.selectedParty.type = "is-primary";
                    }
                    else {
                        self.selectedCoverage.pack = "fas";
                        self.selectedCoverage.icon = "star-half";
                        self.selectedCoverage.type = "is-primary";
                    }
                    break;
                case '2':
                    if (self.isBulk) {
                        self.selectedParty.pack = "fas";
                        self.selectedParty.icon = "star";
                        self.selectedParty.type = "is-primary";
                    }
                    else {
                        self.selectedCoverage.pack = "fas";
                        self.selectedCoverage.icon = "star";
                        self.selectedCoverage.type = "is-primary";
                    }
                    break;
            }

            const parsedCoverage = parseInt(self.coverage);

            if (self.isBulk) {
                self.$services.partyCoveragesService.bulkSave({
                    partyId: self.selectedParty.id,
                    classificationSystemId: self.selectedParty.classificationSystemId,
                    coverage: parsedCoverage
                }).then((data) => {
                    if (data) {
                        self.$buefy.snackbar.open(`The party coverages were successfully stored`);
                        self.showCoverageFormModal = false;
                        self.initialize();
                    }
                    else {
                        self.$buefy.snackbar.open(`The party coverages were not stored`);
                    }
                });
            }
            else {
                self.selectedCoverage.coverage = parsedCoverage;

                self.$services.partyCoveragesService.save({
                    partyId: self.selectedCoverage.partyId,
                    classificationHierarchyId: self.selectedProduct.id,
                    classificationSystemId: self.selectedProduct.classificationSystemId,
                    productCode: self.selectedCoverage.productCode,
                    coverage: self.selectedCoverage.coverage
                }).then((data) => {
                    if (data) {
                        self.$buefy.snackbar.open(`The party coverage was successfully stored`);
                        self.showCoverageFormModal = false;
                        self.initialize();
                    }
                    else {
                        self.$buefy.snackbar.open(`The party coverage was not stored`);
                    }
                });
            }
        },
        modifyCoverage(coverage, product) {
            const self = this;

            self.selectedProduct = product;
            self.productName = `${product.productCode}  - ${product.productDescription}`;
            self.selectedCoverage = coverage;
            self.isBulk = false;
            self.showCoverageFormModal = true;
        },
        modifyPartyCoverage(party) {
            const self = this;

            self.selectedParty = party;
            self.isBulk = true;
            self.showCoverageFormModal = true;
        }

    },
    mounted() {
        this.initialize();
    },
    template: `
		<div>
			<template v-if="loading"><loading></loading></template>
			<template v-else>
				<table class="table table-bordered" v-if="products != null && products.length > 0">
                    <thead>
                        <tr>
                            <td style="width: 400px; vertical-align: middle; text-align: center; overflow-x:auto;">{{description}}</td>
                            <td v-for="party in parties" class="vertical-table-header">
                                <span>{{ party.name }}</span>
                                <a href="#" @click.prevent="modifyPartyCoverage(party)">
                                    <b-icon :pack="party.pack" :icon="party.icon" :type="party.type" size="is-small"></b-icon>
                                </a>
                            </td>
                        </tr>
                    </thead>
                    <tbody>                        
                        <tr v-for="(product, index) in products">
                            <td :style="{ 'padding-left': ((product.tier - 1) * 10) + 'px' }">
                                <a href="#" v-if="product.childrenCount > 0" @click.prevent="loadChildren(product, index)">
                                    <b-icon :icon="product.icon" pack="fas" size="is-small"></b-icon>
                                </a>
                                <span>{{ product.productCode }} - {{ product.productDescription }}</span>                                
                                
                            </td>
                            <td class="coverage-td" v-for="coverage in product.coverages">
                                <a href="#" @click.prevent="modifyCoverage(coverage, product)">
                                    <b-icon :pack="coverage.pack" :icon="coverage.icon" :type="coverage.type" size="is-small"></b-icon>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <b-message type="is-info" v-else>
                    There is no coverage found for this classification.
                </b-message>
			</template>
            <b-modal id="coverageFormModal" ref="coverageFormModal" v-model="showCoverageFormModal" #default="props" :canCancel="false">
                <div class="modal-card" style="overflow-y: auto;">
                    <header class="modal-card-head">
                        <p class="modal-card-title">Coverage</p>
                    </header>
                    <section class="modal-card-body">
                        <div class="card">
                            <div class="card-content">                                
                                <table class="table is-striped is-narrow is-hoverable">
                                    <thead>
                                        <tr>
                                            <td colspan="3"><p>Select the coverage for <b>{{classificationCode}} : {{productName}}</b></p></td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <b-radio v-model="coverage"
                                                    name="coverage"
                                                    native-value="0">
                                                </b-radio>
                                            </td>
                                            <td>
                                                <b-icon pack="far" icon="star" type="is-success" size="is-small"></b-icon>
                                            </td>
                                            <td>Not covered</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <b-radio v-model="coverage"
                                                    name="coverage"
                                                    native-value="1">
                                                </b-radio>
                                            </td>
                                            <td>
                                                <b-icon pack="fas" icon="star-half" type="is-primary" size="is-small"></b-icon>
                                            </td>
                                            <td>Partially covered</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <b-radio v-model="coverage"
                                                    name="coverage"
                                                    native-value="2">
                                                </b-radio>
                                            </td>
                                            <td>
                                                <b-icon pack="fas" icon="star" type="is-primary" size="is-small"></b-icon>
                                            </td>
                                            <td>Fully covered</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="card-footer">
                                <div class="buttons">
                                    <button type="button" class="button is-primary" @click="saveCoverage">Save</button>
                                    <button type="button" class="button is-danger" @click="discardCoverage">Cancel</button>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </b-modal>
		</div>
	`
});